export default "__VITE_ASSET__b6bbfe73__"